import clamp from 'utils/clamp';

import { HorizontalContainer, IconButton, VerticalContainer } from '@american-autonomy/ag-ui';

import MinusIcon from 'components/icons/MinusIcon';
import PlusIcon from 'components/icons/PlusIcon';
import BodyText from 'components/text/BodyText';
import LabelText from 'components/text/LabelText';

import { DEFAULT_STEP, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const StepperField: FunctionComponent<Props> = ({
    className = '',
    disabled = false,
    label,
    max,
    min,
    onChange,
    step = DEFAULT_STEP,
    testId = TEST_ID,
    value
}) => {
    const labelDisabledClass = disabled ? styles.labelDisabled : '';
    const valueDisabledClass = disabled ? styles.valueDisabled : '';

    const handleDecrement = () => {
        if (disabled) {
            return;
        }

        onChange({ value: clamp({ max, min, value: value - step }) });
    };

    const handleIncrement = () => {
        if (disabled) {
            return;
        }

        onChange({ value: clamp({ max, min, value: value + step }) });
    };

    return (
        <VerticalContainer className={`${className} ${styles.stepperField}`} testId={testId}>
            <LabelText className={`${labelDisabledClass} ${styles.label}`} text={label} />

            <HorizontalContainer className={styles.controls}>
                <IconButton
                    className={styles.decrementButton}
                    isDisabled={disabled || value <= min}
                    onClick={handleDecrement}>
                    <MinusIcon />
                </IconButton>

                <BodyText
                    className={`${valueDisabledClass} ${styles.value}`}
                    text={String(value)}
                />

                <IconButton
                    className={styles.incrementButton}
                    isDisabled={disabled || value >= max}
                    onClick={handleIncrement}>
                    <PlusIcon />
                </IconButton>
            </HorizontalContainer>
        </VerticalContainer>
    );
};

export default StepperField;
